<template>
      <DashBoardLayout :showNavbar=false :isSearch=false >
          <div class="row w100">
              <div class="w100 mb-2">
                  <v-stepper alt-labels>
                      <v-stepper-header>
                          <v-stepper-step step="1" @click="setTab(1)">Order Summary</v-stepper-step>
                          <v-divider></v-divider>
                          <v-stepper-step step="2" @click="setTab(2)">Address</v-stepper-step>
                          <v-divider></v-divider>
                          <v-stepper-step step="3" @click="setTab(3)">Payments</v-stepper-step>
                      </v-stepper-header>
                  </v-stepper>
              </div>
              <div class="col-xl-11 auto col-lg-11 bg_white" v-if="tab1">
                  <div class="pt-4 pb-4 d-address-wrapper">
                      <div class="your-orders">
                          <form method="post" id="checkout_form">
                              <table class="table-wrapper table cart_table">
                                  <tbody>
                                      <tr v-for="item in cart" :key="item.product_id">
                                          <td><b>{{item.name}}</b> <span>{{item.packing}}</span></td>
                                          <td>
                                              <br>
                                              <span class="pl-2" style="font-size:15px;">&#8377;{{item.mrp}}</span>
                                          </td>
                                          <td>
                                              <!-- qty increase or decrease -->
                                              <div class="qtySelector text-center mt-2 ">
                                                <i class="increaseQty fa-plus fa" @click="subqty(item.product_id)">
                                                    <v-icon>remove</v-icon>
                                                </i>
                                                  <input type="text" class="qtyValue" :value="item.qty">
                                                <i @click="addqty(item.product_id)" class="decreaseQty fa fa-minus">
                                                    <v-icon>add</v-icon>
                                                </i>
                                              </div>
               
                                          </td>
                                          <td>&#8377;{{item.mrp*item.qty}}</td>
                                          <td>
                                              <v-icon class="pointer delete-cart-item" @click="removeCartItem(item.product_id)">delete</v-icon>
                                          </td>
                                      </tr>
                                  </tbody>
                                  <div class="mt-5 pb-3">
                                      <h3>Total <span>Rs.{{getCartTotal}}/-</span> </h3>
                                  </div>
                                  <div v-if="countCart==0">
                                      <h2>No Cart Item Selecetd</h2>
                                  </div>
                                  <input type="hidden" name="delivery_address" id="address_id" value="<?= $address_id_default ?>" required="">
                                  <input type="hidden" name="payment_mode" id="payment_mode" value="" required="">
                              </table>
                              <!-- <v-btn depressed color="primary" @click="setTab(2)">
                          Continue
                      </v-btn> -->
                              <div class="w100 mt-3">
                                  <button class="primary-btn-kr-outline">
                                      <router-link to="/">Add more items</router-link>
                                  </button>
                                  <button @click="setTab(2)" class="primary-btn-kr mt-3 ml-2">Continue</button>
                                  <button class="mr-4 secondary-btn-kr" @click="clearCart()">Clear Cart</button>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
              <div class="col-xl-11 auto col-lg-11" v-if="tab2">
                  <Address v-on:onChange="assign_delivery($event)"></Address>
                  <div class="w100 d-address-wrapper mt-3">
                     <h5>Total <span>Rs.{{getCartTotal}}/-</span> </h5>
                        <button @click="setTab(1)" class="primary-btn-kr-outline">
                            Back
                        </button>
                        <button @click="setTab(3)"  class="primary-btn-kr mt-3 ml-2">Next</button>
                              </div>
              </div>
              <div class="col-xl-11 auto col-lg-11" v-if="tab3">
                  <Payments v-on:onPaymentChange="choose_payment($event)"></Payments>
                      <div class="w100 mt-3">
                  <h5>Total <span>Rs.{{getCartTotal}}/-</span> </h5>
                   <button @click="setTab(2)" class="primary-btn-kr-outline">
                                      Back
                                  </button>
                <button @click="checkout()" class="primary-btn-kr mt-3 ml-2">Proceed Payment</button>
                  </div>
              </div>
          </div>
      </DashBoardLayout>
  </template>
  <script>
      import axios from "axios"
      import Address from './Address.vue'
      import Payments from './Payments_tab.vue'
      import ApiList from '../ApiList'
      import globalMixins from '../globalMixins'
      import DashBoardLayout from '../../layouts/DashboardLayout.vue'
      export default {
          components: {
              Address,
              Payments,DashBoardLayout
          },
          name: 'Cart',
          mixins: [ApiList,globalMixins],
          //  created(){
          //     this.$emit(`update:layout`,DashBoardLayout)
          // },
          data() {
              return {
                  customer_id: '',
                  cart: [],
                  tab1: true,
                  tab2: false,
                  tab3: false,
                  delivery_address: 0,
              }
          },
          mounted() {
              this.loadData()
          },

          methods: {
              clearCart(){
                  if(this.cart!=null)
                  {
                      localStorage.removeItem('cart');
                      this.cart.splice(0,this.cart.length);
                  }
              },
              setTab(opt) {
                  if (opt == 1) {
                      this.tab1 = true
                      this.tab2 = false
                      this.tab3 = false

                  } else if (opt == 2) {
                      if (this.cart.length == 0 || this.cart == null) {
                          this.$router.push("/")
                      } else {
                          this.tab1 = false
                          this.tab2 = true
                          this.tab3 = false
                      }
                  } else {
                      console.log("dd"+this.delivery_address);
                      let length = this.delivery_address.length;
                      if (length == 0 || this.delivery_address == undefined || this.delivery_address == null) {
                          alert("plz select any address!")
                      } else {
                          this.tab1 = false
                          this.tab2 = false
                          this.tab3 = true

                      }
                  }
              },
              loadData() {
                  this.customer_id = localStorage.getItem("customer_id")
                  this.cart = JSON.parse(localStorage.getItem("cart"));
                  if(this.cart==null)
                      this.cart=[];
                  // this.loadAddress()
              },
              // updateCart() {
              //     // this.total = this.getCartTotal()
              //     // this.cartLength = this.cart.length
              //     localStorage.setItem("cart", JSON.stringify(this.cart));
              // },
              removeCartItem(pid) {
                  var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
                  this.cart.splice(objIndex, 1); //to Remove Element from Arry
                  this.updateCart()
              },
              // addqty(pid) {
              //     //  alert(pid);
              //     var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
              //     var qty_old = parseInt(this.cart[objIndex].qty);
              //     this.cart[objIndex].qty = qty_old + 1;
              //     // alert(objIndex)
              //     this.updateCart();
              // },
              // subqty(pid) {
              //     // alert(pid+" "+q)
              //     var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
              //     var q = parseInt(this.cart[objIndex].qty);
              //     if (q > 1) {
              //         this.cart[objIndex].qty -= 1;

              //     } else {
              //         this.cart.splice(objIndex, 1); //to Remove Element from Arry
              //     }
              //     // alert(this.cart[objIndex].qty)
              //     this.updateCart();
              // },
              checkout: function () {
                  console.log("cart: " + this.cart);
                  if (this.cart.length > 0) {
                      // alert(this.delivery_address)
                      let length = this.delivery_address.length;
                      if (length == 0 || this.delivery_address == undefined || this.delivery_address == null) {
                          alert("plz select any address!")
                      } else {
                          if (this.payment_mode == '' || this.payment_mode == undefined || this.payment_mode == null) {
                              alert("plz select Payment Mode !")
                          } else {
                              this.proceedCart()
                          }

                      }
                  } else {
                      alert("select Cart Items !")
                  }
              },
              proceedCart: function () {
                  var obj = JSON.stringify(this.cart);
                  console.log(obj);
                  var CartObj = btoa(obj);

                  console.log("checkout clicked!!");
                  if (this.customer_id > 0) {
                      console.log(CartObj);
                      var saveCartURL = this.apis.apiUrl + this.apis.cartURL

                      axios.get(saveCartURL, {
                              params: {
                                  token: localStorage.token,
                                  order_data: CartObj,
                                  customer_id: this.customer_id,
                                  delivery_address: this.delivery_address,
                                  payment_mode: this.payment_mode
                              }
                          })
                          .then((response) => {
                              console.log(response)
                              console.log("sent above cart data....");
                              if (response.data.error == 0) {
                                  localStorage.removeItem("cart");
                                  var orderId = response.data.order
                                  // setTimeout(() => {
                                  // window.location = "<?=base_url()?>Customer/orders";
                                  // this.$router.push('Thanku') 

                                  // }, 600);
                                  this.$router.push('/thankyou/'+orderId);
                              } else {
                                  this.error_show = true
                              }
                          });
                      //localStorage.removeItem("cart");		            } else {
                      this.customer_id = 0;
                      console.log("showing login..");
                      // this.showLogin();
                      // $("#gotocart_login").val("allproducts");
                  }
              },
              assign_delivery(address_id) {
                  // console.log(address_id)
                  this.delivery_address = address_id;
              },
              choose_payment(payment_method) {
                  console.log(payment_method)
                  this.payment_mode = payment_method;
              },

          },
          computed: {
              countCart: function () {
                  // `this` points to the vm instance
                  return this.cart.length
              },
              getCartTotal: function () {
                  var t = 0
                  if (this.cart != null) {
                      t = this.cart.reduce((acc, item) => acc + (parseInt(item.mrp) * parseInt(item.qty)), 0);
                  }
                  return t
              }

          }
      }
  </script>
  <style>

  
           .qtySelector {
          border: 1px solid #e0edf1;
          width: 107px;
          height: 35px;
          background: #e8f4f8;
      }

      .qtySelector input {
          background: #f9fefe;
          margin-top: 0 !important;
      }

      .qtySelector .fa {
          padding: 10px 5px;
          width: 35px;
          height: 100%;

          float: left;
          display: flex;
          align-items: center;
          cursor: pointer;
      }

      .qtySelector .fa.clicked {
          font-size: 12px;
          padding: 12px 5px;
      }


      .qtySelector .qtyValue {
          border: none;
          padding: 5px;
          width: 35px;
          height: 100%;
          float: left;
          text-align: center;
      }

      input {
          border: none !important;
          ;
      }

      @media only screen and (max-width: 959px) {
          .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
              display: block !important;
              font-size: 13px !important;
          }

          .v-stepper--alt-labels .v-stepper__step {
              flex-basis: auto !important;
              ;
          }
      }
  </style>